import { z } from "zod";
export const ReviewShortcutsSchema = z.object({
    reveal: z.string().min(1),
    hint: z.string().min(1),
    again: z.string().min(1),
    hard: z.string().min(1),
    good: z.string().min(1),
    easy: z.string().min(1),
});
export const DEFAULT_REVIEW_SHORTCUTS = {
    reveal: "Enter",
    hint: "?",
    again: "1",
    hard: "2",
    good: "3",
    easy: "4",
};
// Namespaced by feature area so future shortcut categories (e.g. create-page
// shortcuts) can be added here without another migration.
export const ShortcutsSchema = z.object({
    review: ReviewShortcutsSchema,
});
export const DEFAULT_SHORTCUTS = {
    review: DEFAULT_REVIEW_SHORTCUTS,
};
export const UpdateShortcutsRequestSchema = z.object({
    review: ReviewShortcutsSchema.optional(),
});
export const UserSettingsSchema = z.object({
    daily_new_card_limit: z.number().int().min(0).max(200),
    desired_retention: z.number().min(0.7).max(0.97),
    shortcuts: ShortcutsSchema,
    personal_context: z.string().max(300),
});
export const UpdateUserSettingsRequestSchema = z.object({
    daily_new_card_limit: z.number().int().min(0).max(200).optional(),
    desired_retention: z.number().min(0.7).max(0.97).optional(),
    shortcuts: UpdateShortcutsRequestSchema.optional(),
    personal_context: z.string().max(300).optional(),
});
//# sourceMappingURL=settings.js.map